import React__default from 'react';
import styled from 'styled-components';
import sx from '../../sx.js';
import { themeGet } from '../../utils/theme-get.js';
import Text from '../Text/Text.js';
import Link from '../Link/Link.js';
import Box from '../Box/Box.js';
import VisuallyHidden from '../VisuallyHidden/VisuallyHidden.js';
import Logo from '../Logo/Logo.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const StyledNavTitle = styled(Text).withConfig({
  displayName: "HeaderNavTitle__StyledNavTitle",
  componentId: "sc-19ez1c8-0"
})(["text-decoration:none;font-size:", ";font-weight:", ";"], themeGet('fontSizes.4'), themeGet('fontWeights.semibold'));
const StyledNavSubtitle = styled(Text).withConfig({
  displayName: "HeaderNavTitle__StyledNavSubtitle",
  componentId: "sc-19ez1c8-1"
})(["text-decoration:none;font-size:", ";color:", ";font-weight:", ";"], themeGet('fontSizes.2'), themeGet('colors.text.subtle'), themeGet('fontWeights.medium'));
const StyledNavButton = styled.button.withConfig({
  displayName: "HeaderNavTitle__StyledNavButton",
  componentId: "sc-19ez1c8-2"
})(["appearance:none;margin:0;padding:0;border:none;background:transparent;cursor:pointer;text-align:left;font:inherit;text-decoration:none;color:", ";display:inline-flex;align-items:center;gap:", ";&:hover{text-decoration:none;}&:focus,.focus-visible{outline:none;transition-duration:0s,0.2s;box-shadow:0 0 0 2px ", ";border-radius:", ";}&:focus:not(:focus-visible):not(.focus-visible){box-shadow:0 0 0 2px ", ";border-radius:", ";}", ""], themeGet('colors.text.default'), themeGet('space.2'), themeGet('colors.border.focused'), themeGet('radii.2'), themeGet('colors.border.focused'), themeGet('radii.2'), sx);
const StyledNavLink = styled(Link).withConfig({
  displayName: "HeaderNavTitle__StyledNavLink",
  componentId: "sc-19ez1c8-3"
})(["text-decoration:none;color:", ";display:inline-flex;align-items:center;gap:", ";&:hover{text-decoration:none;}&:focus,.focus-visible{outline:none;transition-duration:0s,0.2s;box-shadow:0 0 0 2px ", ";border-radius:", ";}&:focus:not(:focus-visible):not(.focus-visible){box-shadow:0 0 0 2px ", ";border-radius:", ";}", ""], themeGet('colors.text.default'), themeGet('space.2'), themeGet('colors.border.focused'), themeGet('radii.2'), themeGet('colors.border.focused'), themeGet('radii.2'), sx);
/**
 * Navigation link item for a Header component
 */
const HeaderNavTitleLink = ({
  children,
  href,
  active,
  onSelect,
  ...props
}) => {
  if (href && onSelect) {
    throw new Error(`HeaderNav Links take an onSelect or an href prop, but not both. See: https://fuegokit.design/react/patterns/global-header.`);
  }
  if (href) {
    return /*#__PURE__*/React__default.createElement(StyledNavLink, _extends({
      href: href
    }, props), children);
  }
  if (onSelect) {
    return /*#__PURE__*/React__default.createElement(StyledNavButton, _extends({
      onClick: onSelect
    }, props), children);
  }
  throw new Error(`Provide the NavLink an onSelect or an href prop. See: https://fuegokit.design/react/patterns/global-header.`);
};

// --------------------------------------------------------
// Header NavTitle
/**
 * Rule Builder Nav Title. Must be rendered inside a GlobalHeader.Nav component
 */
const HeaderNavTitle = ({
  href,
  appLogoUrl,
  appLogoImgAlt,
  subtitle,
  title,
  resized,
  onSelect,
  ...props
}) => {
  if (appLogoUrl && !appLogoImgAlt) {
    console.warn(`You must include accessible alt text to describe your logo image. Please refer to https://www.w3.org/WAI/tutorials/images/.`);
  }
  return /*#__PURE__*/React__default.createElement(HeaderNavTitleLink, _extends({
    href: href,
    onSelect: onSelect
  }, props), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(VisuallyHidden, {
    id: "mainmenulabel"
  }, "Main menu"), appLogoUrl ? /*#__PURE__*/React__default.createElement(Box, {
    as: "img",
    src: appLogoUrl,
    alt: appLogoImgAlt,
    style: subtitle && !resized ? {
      height: '44px',
      width: '44px'
    } : {
      height: '20px',
      width: '20px'
    },
    sx: {
      display: 'block'
    }
  }) : /*#__PURE__*/React__default.createElement(Logo, {
    variant: "solid",
    size: 20,
    color: "inherit",
    "aria-hidden": "true"
  })), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React__default.createElement(StyledNavTitle, null, title), subtitle && !resized && /*#__PURE__*/React__default.createElement(StyledNavSubtitle, null, subtitle)));
};
HeaderNavTitle.displayName = "HeaderNavTitle"; // --------------------------------------------------------
// Header Nav Title Link
var HeaderNavTitle$1 = HeaderNavTitle;

export { HeaderNavTitle$1 as default };
